import { isMobile } from '../../helpers/Helper';
import { HelperConstant } from 'components/constants/dsmConstants';
import React, { InputHTMLAttributes, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
    Toast,
    ToastHeader,
    ToastBody,
    Col,
} from "reactstrap";
interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    /** @param {string} message message you want to toast*/
    message: string;
    /** @param {any} color is defines the color of the toast*/
    color: "text-success" | "text-danger" | "text-warning" | "text-white",
    /** @param {boolean} toast is defines showing toast*/
    toast: boolean,
    /** @param {any} setToast is defines Toast & Timeout*/
    setToast: any,
    /** @param {any} path is defines the path which we have to navigate*/
    path?: string
    customTime?: number,
    customStyle?: any
}

export const CustomToaster = React.forwardRef(({ message, color, toast, setToast, path, customTime, customStyle }: inputProps, ref) => {

    const toggleToast = () => {
        setToast(!toast);
    };
    let navigate = useNavigate();

    useEffect(() => {
        if (toast) {
            setTimeout(() => {
                setToast(false);
                if (path) {
                    navigate(path);
                }
            }, customTime ? customTime : HelperConstant.TOAST_TIMEOUT);
        }
    }, [toast]);

    return (
        <React.Fragment>
            <div className="top-0 end-0 p-3" style={{ left: isMobile() ? "10px" : "40%", position: "fixed", zIndex: "9999" }}>
                <Col sm={12} className='text-center'>
                    <Toast isOpen={toast} className={`${color == "text-danger" ? "bg-danger" : color == "text-warning" ? "bg-warning" : "bg-success"} align-items-center border-0`} role='alert'>
                        <ToastHeader toggle={toggleToast}>
                            <ToastBody className={color}>
                                {message}
                            </ToastBody>
                        </ToastHeader>
                    </Toast>
                </Col>
            </div>
        </React.Fragment >
    );
})

